export const MAX_COINS: number = Infinity;
export const MAX_KEYS: number = 999;
export const MAX_WHEEL_SPINS: number = 99;
export const MAX_EXTRA_CARDS: number = 10;
export const MAX_FREE_CHESTS: number = 1;

export const FRIEND_SHARE_MAX_COUNT: number = 10;

export const INITIAL_PREMIUM_SPINS_AMOUNT = 5;
